// extracted by mini-css-extract-plugin
export default {"text":"SubInfo-text_EFgxl","inline":"SubInfo-inline_xIsYn"};